






























































































import { API_EXPENSE_CATEGORY_LIST } from "@/configs/Apis";
import formatters from "@/utils/ColumnFormater";
import {
  hasPermission,
  isEmptyOrWhiteSpace,
  showConfirm,
  showSuccess,
  showError,
  showWarning,
} from "@/utils/Common";
import ExpenseCategoryForm from "@/views/setting/subviews/ExpenseCategoryForm.vue";
import { TableColumn } from "element-ui/types/table-column";
import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {
    ExpenseCategoryForm,
  },
})
export default class ExpenseCategoryList extends Vue {
  queryData: any = { name: "" };

  addExpenseCategoryFormDialogVisible = false;
  expenseCategoryItem: any = { id: 0 };

  hasSelectedItems = false;

  queryStr = "";
  loadData = false;

  showSearch = false;

  get searchBtnIcon(): string {
    return this.showSearch ? "el-icon-arrow-up" : "el-icon-arrow-down";
  }

  get dataApi() {
    return API_EXPENSE_CATEGORY_LIST;
  }

  get colFormatters() {
    return formatters;
  }

  hasPerm(checkedPerm: string) {
    return hasPermission(this.$store.getters["user/user"] || {}, checkedPerm);
  }

  createTableColumns() {
    const columns: Array<TableColumnOption> = [
      { prop: "name", display: "名称", width: 200 },
      { prop: "remark", display: "备注" }
    ];
    this.$store.dispatch("expense/setColumns", columns);
  }

  reloadData() {
    this.searchData();
  }

  onModuleRegistered() {
    this.$nextTick()
      .then(() => this.createTableColumns())
      .then(() => {
        this.onSearchConditionChange();
      });
  }

  onTextKeyup() {
    ((this.$refs.searchBtn as Vue).$el as HTMLInputElement).focus();
  }

  onSearchConditionChange() {
    const params: { [key: string]: any } = {};
    if (!isEmptyOrWhiteSpace(this.queryData.name)) {
      params.name = this.queryData.name;
    }
    const paramsStr = JSON.stringify(params);
    if (paramsStr === "{}" && this.queryStr.trim() === "") {
      this.queryStr = "{}";
      return;
    }
    if (paramsStr !== this.queryStr.trim()) {
      this.queryStr = JSON.stringify(params);
    }
  }

  searchData() {
    if (this.queryStr.endsWith(" ")) {
      this.queryStr = this.queryStr.trim();
    } else {
      this.queryStr += " ";
    }
  }

  addExpenseCategory() {
    this.expenseCategoryItem = { id: 0, name: "" };
    this.addExpenseCategoryFormDialogVisible = true;
  }

  addExpenseCategorySuccess() {
    this.addExpenseCategoryFormDialogVisible = false;
    this.reloadData();
    this.expenseCategoryItem = { id: 0, name: "" };
  }

  editExpenseCategory() {
    const selectedRows = (this.$refs.expensecategorygrid as any).getSelectedDataRows();
    if (!selectedRows || selectedRows.length === 0) {
      showWarning("请选择一个分类");
      return;
    }
    this.expenseCategoryItem = JSON.parse(JSON.stringify(selectedRows[0]));
    this.addExpenseCategoryFormDialogVisible = true;
  }

  onSelectionChanged(selectedRows: any[]) {
    this.hasSelectedItems = selectedRows.length > 0;
  }

  onRowClick(command: string, data: any, event: MouseEvent) {
    //
  }

  onColumnResize(newWidth: number, column: TableColumn) {
    this.$store.dispatch("expense/setColumnWidth", {
      listName: "expenseCategory",
      column: column.property,
      newWidth,
    });
  }

  onTableDataLoaded() {
    //
  }

  openSearchPanel() {
    this.showSearch = !this.showSearch;
  }

  batchDeleteData(cmd: string) {
    let params: any = {};
    let msg = "当前列表";
    if (cmd === "selected") {
      const selectedRows = (this.$refs.expensecategorygrid as any).getSelectedRows();
      if (!selectedRows || selectedRows.length === 0) {
        showWarning("请至少选择一条数据");
        return;
      }
      params.selectedIds = selectedRows;
      msg = `${selectedRows.length} 条数据`;
    } else {
      if (!isEmptyOrWhiteSpace(this.queryStr)) {
        params = JSON.parse(this.queryStr);
      }
    }
    showConfirm(`是否确认删除 ${msg}？`).then(() => {
      this.$store
        .dispatch("expense/deleteExpenseCategory", params)
        .then(() => {
          showSuccess("删除成功");
          this.reloadData();
        })
        .catch(({ message }) => showError(message));
    });
  }
}
